import React, {Component} from 'react';
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";

class CustomGoogleMap extends Component {
	render() {
		return <GoogleMap
			defaultZoom={this.props.defaultZoom}
			defaultCenter={this.props.defaultCenter}
		>
			<Marker position={this.props.position}/>
		</GoogleMap>
	}
}

export default withScriptjs(withGoogleMap(CustomGoogleMap));


// WEBPACK FOOTER //
// ./src/03-components/GoogleMap/index.js